import React, { useContext, useState, useEffect } from "react";
import CONSTANSTS from "common/constansts";
import AppCustomToast, { PageContext } from "components/app-custom-toast";
import moment from "moment";
// import moment from "moment";

const PageReportOthers = () => {
  const indicatorValue = useContext(PageContext);
  function messageDialog(indicator) {
    AppCustomToast({
      showIndicator: indicator,
      reintIndicator: indicatorValue[1](indicator),
    });
  }
  // const date = moment().format("YYYY-MM-DD");
  const dateFields = {
    dateFrom: null,
    dateTo: null,
    dateStart: null,
    dateEnd: null,
  };

  const [reportOthers, setReportAccess] = useState({
    generate_aging: false,
    generate_billing_transaction: false,
    generate_fraud_detection: false,
    generate_loan_activity: false,
    generate_settled_contract: false,
    generate_expiring_contract: false,
    generate_auto_reject_expiring_loan_application: false,
    generate_disbursement_report: false,
    generate_outstanding_report: false,
    generate_transaction_without_proof: false,
    generate_audit_trail_report: false,
    generate_custom_audit_trail_report: false,
    get_name_lists: false,
  });

  useEffect(() => {
    let reportAccess = null;
    reportAccess = JSON.parse(localStorage.getItem("accessMatrix"));

    //Testing
    // reportAccess.accessMatrix.Other_Report.generate_aging = false;
    // reportAccess.accessMatrix.Other_Report.generate_billing_transaction = false;
    // reportAccess.accessMatrix.Other_Report.generate_fraud_detection = false;
    // reportAccess.accessMatrix.Other_Report.generate_loan_activity = true;
    // reportAccess.accessMatrix.Other_Report.generate_settled_contract = false;
    if (reportAccess) {
      setReportAccess({
        generate_aging: reportAccess.accessMatrix.Other_Report.generate_aging,
        generate_billing_transaction:
          reportAccess.accessMatrix.Other_Report.generate_billing_transaction,
        generate_fraud_detection:
          reportAccess.accessMatrix.Other_Report.generate_fraud_detection,
        generate_loan_activity:
          reportAccess.accessMatrix.Other_Report.generate_loan_activity,
        generate_settled_contract:
          reportAccess.accessMatrix.Other_Report.generate_settled_contract,
        generate_expiring_contract:
          reportAccess.accessMatrix.Other_Report.generate_expiring_contract,
        generate_auto_rejected_loan_application:
          reportAccess.accessMatrix.Other_Report
            .generate_auto_rejected_loan_application,
        generate_disbursement_report:
          reportAccess.accessMatrix.Other_Report.generate_disbursement,
        generate_outstanding_report:
          reportAccess.accessMatrix.Other_Report.generate_outstanding,
        generate_transaction_without_proof:
          reportAccess.accessMatrix.Other_Report
            .generate_transaction_without_proof,
        generate_audit_trail_report:
          reportAccess.accessMatrix.Other_Report.generate_audit_trail,
        generate_custom_audit_trail_report:
          reportAccess.accessMatrix.Other_Report.generate_custom_audit_trail,
        get_name_lists:
          reportAccess.accessMatrix.Other_Report.get_name_list,
      });
    }

    if (reportAccess.accessMatrix.Other_Report.generate_aging) {
      setFirstMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_fraud_detection
    ) {
      setSecondMenu("display");
    } else if (reportAccess.accessMatrix.Other_Report.generate_loan_activity) {
      setThirdMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_billing_transaction
    ) {
      setForthMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_settled_contract
    ) {
      setFifthMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_expiring_contract
    ) {
      setSixthMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report
        .generate_auto_rejected_loan_application
    ) {
      setSeventhMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_disbursement_report
    ) {
      setEighthMenu("display");
    } else if (reportAccess.accessMatrix.Other_Report.generate_outstanding) {
      setNinthMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_transaction_without_proof
    ) {
      setTenthMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_audit_trail_report
    ) {
      setEleventhMenu("display");
    } else if (
      reportAccess.accessMatrix.Other_Report.generate_custom_audit_trail_report
    ) {
      setTwelfthMenu("display");
    }
  }, []);

  const [firstMenu, setFirstMenu] = useState("hide");
  const [secondMenu, setSecondMenu] = useState("hide");
  const [thirdMenu, setThirdMenu] = useState("hide");
  const [forthMenu, setForthMenu] = useState("hide");
  const [fifthMenu, setFifthMenu] = useState("hide");
  const [sixthMenu, setSixthMenu] = useState("hide");
  const [seventhMenu, setSeventhMenu] = useState("hide");
  const [eighthMenu, setEighthMenu] = useState("hide");
  const [ninthMenu, setNinthMenu] = useState("hide");
  const [tenthMenu, setTenthMenu] = useState("hide");
  const [eleventhMenu, setEleventhMenu] = useState("hide");
  const [twelfthMenu, setTwelfthMenu] = useState("hide");
  const tabClicked = (e) => {
    var menuNo = e;

    if (menuNo === "1") {
      setFirstMenu("display");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "2") {
      setFirstMenu("hide");
      setSecondMenu("display");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "3") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("display");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "4") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("display");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "5") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("display");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "6") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("display");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "7") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("display");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "8") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("display");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "9") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("display");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "10") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("display");
      setEleventhMenu("hide");
      setTwelfthMenu("hide");
    } else if (menuNo === "11") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("display");
      setTwelfthMenu("hide");
    } else if (menuNo === "12") {
      setFirstMenu("hide");
      setSecondMenu("hide");
      setThirdMenu("hide");
      setForthMenu("hide");
      setFifthMenu("hide");
      setSixthMenu("hide");
      setSeventhMenu("hide");
      setEighthMenu("hide");
      setNinthMenu("hide");
      setTenthMenu("hide");
      setEleventhMenu("hide");
      setTwelfthMenu("display");
    }
  };

  //const todayDate = moment(new Date()).format('YYYY-MM-DD');

  const [agingDate, setAgingDate] = useState(dateFields);
  const advacendSearch = {
    name: "",
    mobileNo: "",
    id: "",
  };
  const [agingKeyword, setAgingKeyword] = useState(advacendSearch);
  // const [minDate, setMinDate] = useState("");
  // const [maxDate, setMaxDate] = useState("");

  const ocCustomerName = (event) => {
    const value = event.currentTarget.value.toString();
    setAgingKeyword({
      ...agingKeyword,
      name: value,
    });
  };
  const ocMobileNo = (event) => {
    const value = event.currentTarget.value.toString();
    setAgingKeyword({
      ...agingKeyword,
      mobileNo: value.replace(/\D/, ""),
      // mobileNo: value.replace(/[a-zA-Z !@#$%^&*()_=.<>?/{}|,"':;]/, ""),
    });
  };
  const ocContractId = (event) => {
    const value = event.currentTarget.value.toString();
    setAgingKeyword({
      ...agingKeyword,
      id: value,
      // id: value.replace(/[!@#$%^&*()_+={}|;:'",<.>/? ]/,""),
    });
  };

  const onChangeDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    // setMinDate(value);
    setAgingDate({
      ...agingDate,
      dateFrom: value,
    });
  };

  // const onChangeDateEnd = (event) => {
  //   const value = event.currentTarget.value.toString();
  //   setMaxDate(value);
  //   setAgingDate({
  //     ...agingDate,
  //     dateTo: value,
  //   });
  // };

  const [settledDate, setSettledDate] = useState(dateFields);
  const [settledKeyword, setSettledKeyword] = useState(advacendSearch);
  const [settledMinDate, setSettledMinDate] = useState("");
  const [settledMaxDate, setSettledMaxDate] = useState("");
  const [selectDate, setSelectDate] = useState(dateFields);
  const [selectOutstandingDate, setSelectOutstandingDate] =
    useState(dateFields);

  //For Auto Reject Loan Application Report
  const [autoRejectApplicationDate, setAutoRejectApplicationDate] =
    useState(dateFields);
  const [minAutoRejectApplicationDate, setMinAutoRejectApplicationDate] =
    useState("");
  const [maxAutoRejectApplicationDate, setMaxAutoRejectApplicationDate] =
    useState("");

  //For Loan Contract Disbursement Report
  const [loanContractDate, setLoanContractDate] = useState(dateFields);
  const [minLoanContractDate, setMinLoanContractDate] = useState("");
  const [maxLoanContractDate, setMaxLoanContractDate] = useState("");

  //For Audit Trail Report
  const [auditTrailDate, setAuditTrailDate] = useState(dateFields);
  const [minAuditTrailDate, setMinAuditTrailDate] = useState("");
  const [maxAuditTrailDate, setMaxAuditTrailDate] = useState("");

  //For Custom Audit Trail Report
  const [customAuditTrailDate, setCustomAuditTrailDate] = useState(dateFields);
  const [minCustomAuditTrailDate, setMinCustomAuditTrailDate] = useState("");
  const [maxCustomAuditTrailDate, setMaxCustomAuditTrailDate] = useState("");

  //For Transaction No Proof Report
  const [selectTransactionDate, setSelectTransactionDate] =
    useState(dateFields);

  const scCustomerName = (event) => {
    const value = event.currentTarget.value.toString();
    setSettledKeyword({
      ...settledKeyword,
      name: value,
    });
  };
  const scMobileNo = (event) => {
    const value = event.currentTarget.value.toString();
    setSettledKeyword({
      ...settledKeyword,
      mobileNo: value.replace(/\D/, ""),
    });
  };
  const scContractId = (event) => {
    const value = event.currentTarget.value.toString();
    setSettledKeyword({
      ...settledKeyword,
      id: value,
    });
  };

  const onChangeSCDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setSettledMinDate(value);
    setSettledDate({
      ...settledDate,
      dateFrom: value,
    });
    if (value !== null) {
      setContractStartDate("merchant-input-text");
    }
  };

  const onChangeSCDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setSettledMaxDate(value);
    setSettledDate({
      ...settledDate,
      dateTo: value,
    });
    if (value !== null) {
      setContractEndDate("merchant-input-text");
    }
  };

  const [fraudDate, setFraudDate] = useState(dateFields);
  const [minFraudDate, setMinFraudDate] = useState("");
  const [maxFraudDate, setMaxFraudDate] = useState("");

  const onChangeFraudDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setMinFraudDate(value);
    setFraudDate({
      ...fraudDate,
      dateFrom: value,
    });
  };

  const onChangeFraudDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setMaxFraudDate(value);
    setFraudDate({
      ...fraudDate,
      dateTo: value,
    });
  };

  const [billingDate, setBillingDate] = useState(dateFields);
  const [minBillingDate, setMinBillingDate] = useState("");
  const [maxBillingDate, setMaxBillingDate] = useState("");

  const onChangeBillingDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setMinBillingDate(value);
    setBillingDate({
      ...billingDate,
      dateFrom: value,
    });
  };

  const onChangeBillingDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setMaxBillingDate(value);
    setBillingDate({
      ...billingDate,
      dateTo: value,
    });
  };

  const [activityDate, setActivityDate] = useState(dateFields);
  const [activityKeyword, setActivityKeyword] = useState(advacendSearch);
  const [minActivityDate, setMinActivityDate] = useState("");
  const [maxActivityDate, setMaxActivityDate] = useState("");

  const [statusList, setStatusList] = useState(undefined);
  const [status1, setStatus1] = useState(null);
  const [name, setName] = useState(null);
  const [role, setRole] = useState(null);
  const [nameList, setNameList] = useState("");
  const OnChangeStatus1 = (event) => {
    var value = event.currentTarget.value;
    if (value === "- Select Status -") {
      setStatus1(null);
      value = null;
    } else {
      setStatus1(value);
      console.log(value);
    }
  };

  //On Change Name
  useEffect(() => {
    if (nameList && Array.isArray(nameList.nameList) && nameList.nameList.length > 0) {
      const firstName = nameList.nameList
        .filter((name) => typeof name === 'string' && name.trim() !== '')
        .sort((a, b) => a.localeCompare(b))[0];
      setName(firstName);
    }
  }, [nameList]);

  const OnChangeName = (event) => {
    const value = event.currentTarget.value;
    setName(value);
    console.log(value);
  };

  //GET ROLE NAME LIST
  const OnSelectRole = (event) => {
    var value = event.currentTarget.value;
    if (value === "- Select role -") {
      setRole(null);
      value = null;
    } else {
      setRole(value);
      console.log(value);
    }
    let token = null;
    token = localStorage.getItem("@storage_token");
    try {
        fetch(
          process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GET_NAME_LIST,{
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "*/*",
              "Accept-language": "en",
              "X-DEVICE-OS": "Web",
              Authorization: "Bearer " + token,
            },
            body: JSON.stringify({
              "role": value
            }),
          }
        )
          .then((response) => response.json())
          .then((json) => {
            let res = json.result;
            setNameList(res)
            setName(null);
            console.log(json);
          });
      
    } catch (error) {
      console.error("Error fetching names:", error);
    }
  };

  //Incharge Fetch Status Selection
  useEffect(() => {
    const fetchStatus = async () => {
      fetch(
        process.env.REACT_APP_API_URL +
          CONSTANSTS.ENDPOINT_PATH.COMMON_FIND_DROPDOWN_OPTION +
          "loanStatus",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            "Accept-language": "en",
            "X-DEVICE-OS": "Web",
          },
        }
      )
        .then((response) => response.json())
        .then((json) => {
          let res = json.result;
          setStatusList(res);
        });
    };
    fetchStatus();
  }, []);

  const ocACustomerName = (event) => {
    const value = event.currentTarget.value.toString();
    setActivityKeyword({
      ...activityKeyword,
      name: value,
    });
  };
  const ocAMobileNo = (event) => {
    const value = event.currentTarget.value.toString();
    setActivityKeyword({
      ...activityKeyword,
      mobileNo: value.replace(/\D/, ""),
      // mobileNo: value.replace(/[a-zA-Z !@#$%^&*()_=.<>?/{}|,"':;]/, ""),
    });
  };
  const ocApplicationId = (event) => {
    const value = event.currentTarget.value.toString();
    setActivityKeyword({
      ...activityKeyword,
      id: value,
    });
  };

  const onChangeActivityDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setMinActivityDate(value);
    setActivityDate({
      ...activityDate,
      dateFrom: value,
    });
  };

  const onChangeActivityDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setMaxActivityDate(value);
    setActivityDate({
      ...activityDate,
      dateTo: value,
    });
  };

  const generateAgingReport = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    let sliptStartDate = null;
    // let sliptStartEnd = null;

    if (agingDate.dateFrom !== null) {
      let startDate = null;
      startDate = agingDate.dateFrom;
      sliptStartDate = startDate.split("-");
    }
    // if( agingDate.dateTo !== null ){
    //   let endDate = null;
    //   endDate = agingDate.dateTo;
    //   sliptStartEnd = endDate.split("-");
    // }

    let payload = {
      agingAt: agingDate.dateFrom
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      // dateTo: agingDate.dateTo ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0] : null,
      name: agingKeyword.name ? agingKeyword.name : "",
      mobileNumber: agingKeyword.mobileNo ? agingKeyword.mobileNo : "",
      contractId: agingKeyword.id ? agingKeyword.id : "",
    };
    fetch(
      process.env.REACT_APP_API_URL + CONSTANSTS.ENDPOINT_PATH.GENERATE_AGING,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
          //dialogMessage = dialogMessage;
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  const [contractStartDate, setContractStartDate] = useState(
    "merchant-input-text"
  );
  const [contractEndDate, setContractEndDate] = useState("merchant-input-text");
  const [auditTrailStartDate, setAuditTrailStartDate] = useState(
    "merchant-input-text"
  );
  const [auditTrailEndDate, setAuditTrailEndDate] = useState(
    "merchant-input-text"
  );
  const [customAuditTrailStartDate, setCustomAuditTrailStartDate] = useState(
    "merchant-input-text"
  );
  const [customAuditTrailEndDate, setCustomAuditTrailEndDate] = useState(
    "merchant-input-text"
  );

  const generateSettledReport = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (settledDate.dateFrom !== null) {
      let startDate = null;
      startDate = settledDate.dateFrom;
      sliptStartDate = startDate.split("-");
    } else {
      setContractStartDate("merchant-input-text-error");
      return;
    }
    if (settledDate.dateTo !== null) {
      let endDate = null;
      endDate = settledDate.dateTo;
      sliptStartEnd = endDate.split("-");
      setContractEndDate("merchant-input-text");
    } else {
      setContractEndDate("merchant-input-text-error");
      return;
    }

    let payload = {
      dateFrom: settledDate.dateFrom
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: settledDate.dateTo
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
      name: settledKeyword.name ? settledKeyword.name : "",
      mobileNumber: settledKeyword.mobileNo ? settledKeyword.mobileNo : "",
      contractId: settledKeyword.id ? settledKeyword.id : "",
    };
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_SETTLED_CONTRACT,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  const generateFraudDetection = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (fraudDate.dateFrom !== null) {
      let startDate = null;
      startDate = fraudDate.dateFrom;
      sliptStartDate = startDate.split("-");
    }
    if (fraudDate.dateTo !== null) {
      let endDate = null;
      endDate = fraudDate.dateTo;
      sliptStartEnd = endDate.split("-");
    }

    let payload = {
      dateFrom: fraudDate.dateFrom
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: fraudDate.dateTo
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
      // keyword: fraudKeyword ? fraudKeyword : "",
    };
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_FRAUD_DETECTION,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
          //dialogMessage = dialogMessage
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);

          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  const generateLoanApplicationActivity = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");

    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (activityDate.dateFrom !== null) {
      let startDate = null;
      startDate = activityDate.dateFrom;
      sliptStartDate = startDate.split("-");
    }
    if (activityDate.dateTo !== null) {
      let endDate = null;
      endDate = activityDate.dateTo;
      sliptStartEnd = endDate.split("-");
    }

    let payload = {
      dateFrom: activityDate.dateFrom
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: activityDate.dateTo
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
      name: activityKeyword.name ? activityKeyword.name : "",
      mobileNumber: activityKeyword.mobileNo ? activityKeyword.mobileNo : "",
      applicationId: activityKeyword.id ? activityKeyword.id : "",
      status: status1 ? status1 : "",
    };
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_LOAN_APP_ACTIVITY,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");

        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
          //dialogMessage = dialogMessage
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);

          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  const generateBillingTransaction = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (billingDate.dateFrom !== null) {
      let startDate = null;
      startDate = billingDate.dateFrom;
      sliptStartDate = startDate.split("-");
    }
    if (billingDate.dateTo !== null) {
      let endDate = null;
      endDate = billingDate.dateTo;
      sliptStartEnd = endDate.split("-");
    }

    let payload = {
      dateFrom: billingDate.dateFrom
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: billingDate.dateTo
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
      // keyword: fraudKeyword ? fraudKeyword : "",
      includeVoid: isApprove,
    };
    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_BILLING_TRANSACTION,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");

        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
          //dialogMessage = dialogMessage;
        }

        response.blob().then((blob) => {
          let url = window.URL.createObjectURL(blob);

          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };
  //Incharge Disbursement Report Select Date
  const onChangeLoanContractDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setMinLoanContractDate(value);
    setLoanContractDate({
      ...loanContractDate,
      dateStart: value,
    });
  };

  const onChangeLoanContractDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setMaxLoanContractDate(value);
    setLoanContractDate({
      ...loanContractDate,
      dateEnd: value,
    });
  };

  //Incharge Audit Trail Report Select Date
  const onChangeAuditTrailDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setMinAuditTrailDate(value);
    setAuditTrailDate({
      ...auditTrailDate,
      dateStart: value,
    });
  };

  const onChangeAuditTrailDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setMaxAuditTrailDate(value);
    setAuditTrailDate({
      ...auditTrailDate,
      dateEnd: value,
    });
  };

   //Incharge Custom Audit Trail Report Select Date
   const onChangeCustomAuditTrailDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setMinCustomAuditTrailDate(value);
    setCustomAuditTrailDate({
      ...customAuditTrailDate,
      dateStart: value,
    });
  };

  const onChangeCustomAuditTrailDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setMaxCustomAuditTrailDate(value);
    setCustomAuditTrailDate({
      ...customAuditTrailDate,
      dateEnd: value,
    });
  };

  //Incharge Outstanding Report Select Date
  // const onChangeOutstandingDateStart = (event) => {
  //   const value = event.currentTarget.value.toString();
  //   setMinOutstandingDate(value);
  //   setOutstandingDate({
  //     ...outstandingDate,
  //     dateStart: value,
  //   });
  // };

  // const onChangeOutstandingDateEnd = (event) => {
  //   const value = event.currentTarget.value.toString();
  //   setMaxOutstandingDate(value);
  //   setOutstandingDate({
  //     ...outstandingDate,
  //     dateEnd: value,
  //   });
  // };

  //Incharge Auto rejected expiring select date
  const onChangeAutoRejectApplicationDateStart = (event) => {
    const value = event.currentTarget.value.toString();
    setMinAutoRejectApplicationDate(value);
    setAutoRejectApplicationDate({
      ...autoRejectApplicationDate,
      dateStart: value,
    });
  };

  const onChangeAutoRejectApplicationDateEnd = (event) => {
    const value = event.currentTarget.value.toString();
    setMaxAutoRejectApplicationDate(value);
    setAutoRejectApplicationDate({
      ...autoRejectApplicationDate,
      dateEnd: value,
    });
  };

  //Incharge Expiring loan contract select date
  const onChangeSelectDate = (event) => {
    const value = event.currentTarget.value;
    setSelectDate({
      ...selectDate,
      date: value,
    });
  };

  //Incharge Oustanding select date
  const onChangeSelectOutstandingDate = (event) => {
    const value = event.currentTarget.value;
    setSelectOutstandingDate({
      ...selectOutstandingDate,
      date: value,
    });
  };

  //Incharge Transaction No Proof
  const onChangeSelectTransactionDate = (event) => {
    const value = event.currentTarget.value.toString();
    setSelectTransactionDate({
      ...selectTransactionDate,
      date: value,
    });
  };

  //Expiring Loan Contract Report
  const generateExpiringContractReport = () => {
    let token = null;
    let date = moment(selectDate.date).format("DD/MM/YYYY");
    token = localStorage.getItem("@storage_token");

    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_EXPIRING_CONTRACT +
        "?expiringDate=" +
        date,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  //Auto Rejected Expiring Loan Application Report
  const generateAutoRejectedExpiringLoanApplicationReport = () => {
    let token = null;
    // let date = moment(selectDate.date).format("DD/MM/YYYY");
    token = localStorage.getItem("@storage_token");

    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (autoRejectApplicationDate.dateStart !== null) {
      let startDate = null;
      startDate = autoRejectApplicationDate.dateStart;
      sliptStartDate = startDate.split("-");
    }

    if (autoRejectApplicationDate.dateEnd !== null) {
      let endDate = null;
      endDate = autoRejectApplicationDate.dateEnd;
      sliptStartEnd = endDate.split("-");
    }

    let payload = {
      dateFrom: autoRejectApplicationDate.dateStart
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: autoRejectApplicationDate.dateEnd
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
      // keyword: fraudKeyword ? fraudKeyword : "",
    };

    console.log(payload);

    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH
          .GENERATE_AUTO_REJECTED_EXPIRING_LOAN_APPLICATION,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  //Disbursement Report
  const generateDisbursementReport = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");

    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (loanContractDate.dateStart !== null) {
      let startDate = null;
      startDate = loanContractDate.dateStart;
      sliptStartDate = startDate.split("-");
    }

    if (loanContractDate.dateEnd !== null) {
      let endDate = null;
      endDate = loanContractDate.dateEnd;
      sliptStartEnd = endDate.split("-");
    }

    let payload = {
      dateFrom: loanContractDate.dateStart
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: loanContractDate.dateEnd
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
    };

    console.log(payload);

    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_DISBURSEMENT_REPORT,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  //generate Outstanding Report
  const generateOutstandingReport = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");

    let date = moment(selectOutstandingDate.date).format("DD/MM/YYYY");

    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_OUTSTANDING_REPORT +
        "?outstandingDate=" +
        date,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        // body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  //Transaction Without Proof Report
  const generateTransactionWithoutProofReport = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");

    let date = moment(selectTransactionDate.date).format("DD/MM/YYYY");

    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_TRANSACTION_WITHOUT_PROOF_REPORT +
        "?transactionDate=" +
        date,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        //body: JSON.stringify(date),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  //Audit Trail Report
  const generateAuditTrailReport = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");

    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (auditTrailDate.dateStart !== null) {
      let startDate = null;
      startDate = auditTrailDate.dateStart;
      sliptStartDate = startDate.split("-");
      setAuditTrailStartDate("merchant-input-text");
    } else {
      setAuditTrailStartDate("merchant-input-text-error");
      return;
    }

    if (auditTrailDate.dateEnd !== null) {
      let endDate = null;
      endDate = auditTrailDate.dateEnd;
      sliptStartEnd = endDate.split("-");
      setAuditTrailEndDate("merchant-input-text");
    } else {
      setAuditTrailEndDate("merchant-input-text-error");
      return;
    }

    let payload = {
      dateFrom: auditTrailDate.dateStart
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: auditTrailDate.dateEnd
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
    };

    console.log(payload);

    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_AUDIT_TRAIL_REPORT,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  //Custom Custom Audit Trail Report
  const generateCustomAuditTrailReport = () => {
    let token = null;
    token = localStorage.getItem("@storage_token");
    let sliptStartDate = null;
    let sliptStartEnd = null;

    if (customAuditTrailDate.dateStart !== null) {
      let startDate = null;
      startDate = customAuditTrailDate.dateStart;
      sliptStartDate = startDate.split("-");
      setCustomAuditTrailStartDate("merchant-input-text");
    } else {
      setCustomAuditTrailStartDate("merchant-input-text-error");
      return;
    }

    if (customAuditTrailDate.dateEnd !== null) {
      let endDate = null;
      endDate = customAuditTrailDate.dateEnd;
      sliptStartEnd = endDate.split("-");
      setCustomAuditTrailEndDate("merchant-input-text");
    } else {
      setCustomAuditTrailEndDate("merchant-input-text-error");
      return;
    }

    let payload = {
      dateFrom: customAuditTrailDate.dateStart
        ? sliptStartDate[2] + "/" + sliptStartDate[1] + "/" + sliptStartDate[0]
        : null,
      dateTo: customAuditTrailDate.dateEnd
        ? sliptStartEnd[2] + "/" + sliptStartEnd[1] + "/" + sliptStartEnd[0]
        : null,
      role: role,
      name: name
    };

    console.log(payload);

    fetch(
      process.env.REACT_APP_API_URL +
        CONSTANSTS.ENDPOINT_PATH.GENERATE_CUSTOM_AUDIT_TRAIL_REPORT,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          "Accept-language": "en",
          "X-DEVICE-OS": "Web",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify(payload),
      }
    ).then(function (response) {
      if (response.status === 200) {
        let filename = response.headers.get("Content-Disposition");
        let dialogMessage = response.headers.get("Message");
        if (filename != null) {
          filename = filename.split(";")[1].split("filename=")[1];
        }

        response.blob().then((blob) => {
          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.success,
            title: CONSTANSTS.DIALOG_TITLE.general_success,
            message:
              dialogMessage ?? CONSTANSTS.DIALOG_MESSAGE.download_successful,
            defaultOnClick: false,
          });
          let url = window.URL.createObjectURL(blob);
          let a = document.createElement("a");
          a.href = url;
          a.download = filename;
          a.click();
        });
      } else {
        response.json().then(function (data) {
          const response = data;

          messageDialog({
            isOpen: true,
            condition: CONSTANSTS.DIALOG.failed,
            title: CONSTANSTS.DIALOG_TITLE.general_failed,
            message: response.message,
            defaultOnClick: false,
          });
        });
      }
    });
  };

  // const [agingKeyword, setAgingKeyword] = useState(null);
  const [fraudKeyword, setFraudKeyword] = useState(null);

  // const onChangeAging = (e) => {
  //   const value = e.currentTarget.value;
  //   // setAgingKeyword(value.replace(/\D/, ""));
  //   setAgingKeyword(value);
  // }
  const onChangeFraud = (e) => {
    const value = e.currentTarget.value;
    // setFraudKeyword(value.replace(/\D/, ""));
    setFraudKeyword(value);
  };

  const [isApprove, setIsApprove] = useState(false);
  const handleApprover = () => {
    setIsApprove(!isApprove);
  };

  return (
    <div className="page-report-payment">
      <div className="row">
        <div className="column left-side">
          <div className="card">
            <div className="side-menu">
              {reportOthers.generate_aging && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("1");
                  }}
                  className={firstMenu === "display" ? "clicked" : ""}
                >
                  Aging Report
                </a>
              )}
              {reportOthers.generate_fraud_detection && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("2");
                  }}
                  className={secondMenu === "display" ? "clicked" : ""}
                >
                  Fraud Detection Report
                </a>
              )}
              {reportOthers.generate_loan_activity && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("3");
                  }}
                  className={thirdMenu === "display" ? "clicked" : ""}
                >
                  Loan Application Activity Report
                </a>
              )}
              {reportOthers.generate_billing_transaction && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("4");
                  }}
                  className={forthMenu === "display" ? "clicked" : ""}
                >
                  Billing Transaction Report
                </a>
              )}
              {reportOthers.generate_settled_contract && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("5");
                  }}
                  className={fifthMenu === "display" ? "clicked" : ""}
                >
                  Contract Settlement Report
                </a>
              )}
              {reportOthers.generate_expiring_contract && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("6");
                  }}
                  className={sixthMenu === "display" ? "clicked" : ""}
                >
                  Expiring Contract Report
                </a>
              )}
              {reportOthers.generate_auto_reject_expiring_loan_application && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("7");
                  }}
                  className={seventhMenu === "display" ? "clicked" : ""}
                >
                  Auto Rejected & Expired Loan Application Report
                </a>
              )}
              {reportOthers.generate_disbursement_report && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("8");
                  }}
                  className={eighthMenu === "display" ? "clicked" : ""}
                >
                  Disbursement Report
                </a>
              )}
              {reportOthers.generate_outstanding_report && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("9");
                  }}
                  className={ninthMenu === "display" ? "clicked" : ""}
                >
                  Outstanding Report
                </a>
              )}
              {reportOthers.generate_transaction_without_proof && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("10");
                  }}                  className={tenthMenu === "display" ? "clicked" : ""}
                >
                  Merchant Transaction Without Proof Report
                </a>
              )}
              {reportOthers.generate_audit_trail_report && (
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // ✅ prevents full page reload
                    tabClicked("11");
                  }}
                  className={eleventhMenu === "display" ? "clicked" : ""}
                >
                  Audit Trail Report
                </a>
              )}
              {reportOthers.generate_custom_audit_trail_report && (
                <a
                href="#"
                onClick={(e) => {
                  e.preventDefault(); // ✅ prevents full page reload
                  tabClicked("12");
                }}
                className={twelfthMenu === "display" ? "clicked" : ""}
              >
                Custom Audit Trail Report
              </a>
              )}
              <a href="#" onClick={(e) => {e.preventDefault()}}> </a>
              <a href="#" onClick={(e) => {e.preventDefault()}}> </a>
              <a href="#" onClick={(e) => {e.preventDefault()}}> </a>
              <a href="#" onClick={(e) => {e.preventDefault()}}> </a>
              <a href="#" onClick={(e) => {e.preventDefault()}}> </a>
              <a href="#" onClick={(e) => {e.preventDefault()}}> </a>
              <a href="#" onClick={(e) => {e.preventDefault()}}> </a>
            </div>
          </div>
        </div>

        <div className="column right-side">
          {reportOthers.generate_aging && (
            <div className={firstMenu}>
              <p className="title-text">Aging Report</p>
              <div className="card third-tab">
                <div>
                  <div className="half-menu">
                    <div className="date-select">
                      <div style={{ width: "250px", float: "left" }}>
                        <span>Customer Name</span>
                      </div>
                      <input
                        type="text"
                        onChange={ocCustomerName}
                        value={agingKeyword.name}
                      />
                    </div>
                  </div>
                  <div className="half-menu">
                    <div className="date-select">
                      <div style={{ width: "120px", float: "left" }}>
                        <span>Mobile No</span>
                      </div>
                      <input
                        type="text"
                        onChange={ocMobileNo}
                        value={agingKeyword.mobileNo}
                        maxLength={15}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <div className="half-menu">
                    <div className="date-select">
                      <div style={{ width: "250px", float: "left" }}>
                        <span>Contract ID</span>
                      </div>
                      <input
                        type="text"
                        onChange={ocContractId}
                        value={agingKeyword.id}
                        maxLength={15}
                      />
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "50px" }}>
                  <div className="half-menu">
                    <div className="date-select">
                      <div style={{ width: "250px", float: "left" }}>
                        <span>Aging as at</span>
                      </div>
                      <input
                        type="date"
                        className="merchant-input-text"
                        onChange={onChangeDateStart}
                        value={agingDate.dateFrom}
                      />
                    </div>
                  </div>
                  {/* <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>End</span>
                    </div>
                    <input type="date" className="merchant-input-text" onChange={onChangeDateEnd} value={agingDate.dateTo} min={minDate} style={{ float: "left" }}/>
                  </div>
                </div> */}
                </div>
                <div>
                  <div className="half-menu">
                    <div className="date-select">
                      <div style={{ width: "120px", float: "left" }}>
                        {/* <span>Search</span> */}
                      </div>
                      {/* <input type="text" name="agingKeyword" onChange={onChangeAging} value={agingKeyword}/> */}
                    </div>
                  </div>
                  <div className="half-menu">
                    <div style={{ marginLeft: "220px" }}>
                      <button
                        style={{
                          border: "none",
                          borderRadius: "8px",
                          backgroundColor: "#f5903d",
                          color: "#FFFFFF",
                          fontFamily: "gotham-bold",
                          width: "200px",
                        }}
                        onClick={() => generateAgingReport()}
                      >
                        Generate
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={secondMenu}>
            <p className="title-text">Fraud Detection Report</p>
            <div
              style={{ position: "absolute", right: "70px", top: "62px" }}
            ></div>
            <div className="card third-tab">
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>Start Date</span>
                    </div>
                    <input
                      type="date"
                      className="merchant-input-text"
                      onChange={onChangeFraudDateStart}
                      value={fraudDate.dateFrom}
                      max={maxFraudDate}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div className="date-select">
                    <input
                      type="date"
                      className="merchant-input-text"
                      onChange={onChangeFraudDateEnd}
                      value={fraudDate.dateTo}
                      min={minFraudDate}
                      style={{ float: "right" }}
                    />
                    <div style={{ width: "120px", float: "right" }}>
                      <span>End Date</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div
                      style={{ width: "120px", float: "left", display: "none" }}
                    >
                      <span>Search</span>
                    </div>
                    <input
                      type="text"
                      name="fraudKeyword"
                      onChange={onChangeFraud}
                      value={fraudKeyword}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div style={{ float: "right" }}>
                    <button
                      style={{
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: "#f5903d",
                        color: "#FFFFFF",
                        fontFamily: "gotham-bold",
                        width: "200px",
                      }}
                      onClick={() => generateFraudDetection()}
                    >
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={thirdMenu}>
            <p className="title-text">Loan Application Activity Report</p>
            <div className="card third-tab">
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "250px", float: "left" }}>
                      <span>Customer Name</span>
                    </div>
                    <input
                      type="text"
                      onChange={ocACustomerName}
                      value={activityKeyword.name}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>Mobile No</span>
                    </div>
                    <input
                      type="text"
                      onChange={ocAMobileNo}
                      value={activityKeyword.mobileNo}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "250px", float: "left" }}>
                      <span>Application ID</span>
                    </div>
                    <input
                      type="text"
                      onChange={ocApplicationId}
                      value={activityKeyword.id}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>Status</span>
                    </div>
                    {statusList != undefined ? (
                      <select
                        className=""
                        style={{ marginLeft: "10px", borderRadius: "5px" }}
                        value={status1}
                        onChange={OnChangeStatus1}
                      >
                        <option value="- Select Status -">
                          - Select Status -
                        </option>
                        {statusList
                          .sort((a, b) => (a.sortOrder > b.sortOrder ? 1 : -1))
                          .map((d, i) => (
                            <option value={d.code} key={i}>
                              {d.label}
                            </option>
                          ))}
                      </select>
                    ) : (
                      <select
                        className=""
                        style={{ marginLeft: "10px", borderRadius: "5px" }}
                      >
                        <option value="- Select Status -">
                          - Select Status -
                        </option>
                      </select>
                    )}
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "50px" }}>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "250px", float: "left" }}>
                      <span>Application Date Start</span>
                    </div>
                    <input
                      type="date"
                      className="merchant-input-text"
                      onChange={onChangeActivityDateStart}
                      value={activityDate.dateFrom}
                      max={maxActivityDate}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>End</span>
                    </div>
                    <input
                      type="date"
                      className="merchant-input-text"
                      onChange={onChangeActivityDateEnd}
                      value={activityDate.dateTo}
                      min={minActivityDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      {/* <span>Search</span> */}
                    </div>
                    {/* <input type="text" name="agingKeyword" onChange={onChangeAging} value={agingKeyword}/> */}
                  </div>
                </div>
                <div className="half-menu">
                  <div style={{ marginLeft: "220px" }}>
                    <button
                      style={{
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: "#f5903d",
                        color: "#FFFFFF",
                        fontFamily: "gotham-bold",
                        width: "200px",
                      }}
                      onClick={() => generateLoanApplicationActivity()}
                    >
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={forthMenu}>
            <p className="title-text">Billing Transaction Report</p>
            <div
              style={{ position: "absolute", right: "70px", top: "62px" }}
            ></div>
            <div className="card third-tab">
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>Start Date</span>
                    </div>
                    <input
                      type="date"
                      className="merchant-input-text"
                      onChange={onChangeBillingDateStart}
                      value={billingDate.dateFrom}
                      max={maxBillingDate}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div className="date-select">
                    <input
                      type="date"
                      className="merchant-input-text"
                      onChange={onChangeBillingDateEnd}
                      value={billingDate.dateTo}
                      min={minBillingDate}
                      style={{ float: "right" }}
                    />
                    <div style={{ width: "120px", float: "right" }}>
                      <span>End Date</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className="half-menu">
                  <div className="check-void">
                    {/* <div style={{ float: "left" }}>
                      <span>Include Void Status</span>
                    </div> */}
                    <input
                      type="checkbox"
                      name="includeVoid"
                      id="includeVoid"
                      onChange={handleApprover}
                    />
                    <span>Include void invoice</span>
                  </div>
                </div>
                <div className="half-menu">
                  <div style={{ float: "right" }}>
                    <button
                      style={{
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: "#f5903d",
                        color: "#FFFFFF",
                        fontFamily: "gotham-bold",
                        width: "200px",
                      }}
                      onClick={() => generateBillingTransaction()}
                    >
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={fifthMenu}>
            <p className="title-text">Contract Settlement Report</p>
            <div className="card third-tab">
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "250px", float: "left" }}>
                      <span>Customer Name</span>
                    </div>
                    <input
                      type="text"
                      onChange={scCustomerName}
                      value={settledKeyword.name}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>Mobile No</span>
                    </div>
                    <input
                      type="text"
                      onChange={scMobileNo}
                      value={settledKeyword.mobileNo}
                      maxLength={15}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "250px", float: "left" }}>
                      <span>Contract ID</span>
                    </div>
                    <input
                      type="text"
                      onChange={scContractId}
                      value={settledKeyword.id}
                      maxLength={15}
                    />
                  </div>
                </div>
              </div>
              <div style={{ marginTop: "50px" }}>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "250px", float: "left" }}>
                      <span>Settled As At</span>
                    </div>
                    <input
                      type="date"
                      className={contractStartDate}
                      onChange={onChangeSCDateStart}
                      value={settledDate.dateFrom}
                      max={settledMaxDate}
                    />
                  </div>
                </div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>End</span>
                    </div>
                    <input
                      type="date"
                      className={contractEndDate}
                      onChange={onChangeSCDateEnd}
                      value={settledDate.dateTo}
                      min={settledMinDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="half-menu">
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      {/* <span>Search</span> */}
                    </div>
                    {/* <input type="text" name="agingKeyword" onChange={onChangeAging} value={agingKeyword}/> */}
                  </div>
                </div>
                <div className="half-menu">
                  <div style={{ marginLeft: "220px" }}>
                    <button
                      style={{
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: "#f5903d",
                        color: "#FFFFFF",
                        fontFamily: "gotham-bold",
                        width: "200px",
                      }}
                      onClick={() => generateSettledReport()}
                    >
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={sixthMenu}>
            <p className="title-text">Expiring Contract Report</p>
            <div className="card third-tab">
              <div>
                <div className="half-menu">
                  <div style={{ float: "left" }}>
                    <span>Select Date : </span>
                  </div>
                  <input
                    type="date"
                    className={contractEndDate}
                    onChange={onChangeSelectDate}
                    value={selectDate.date}
                    style={{ float: "left" }}
                  />
                </div>
                <div className="half-menu">
                  <div style={{ marginLeft: "220px" }}>
                    <button
                      style={{
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: "#f5903d",
                        color: "#FFFFFF",
                        fontFamily: "gotham-bold",
                        width: "200px",
                      }}
                      onClick={() => generateExpiringContractReport()}
                    >
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={seventhMenu}>
            <p className="title-text">
              Auto Rejected & Expired Loan Application Report
            </p>
            <div className="card third-tab">
              <div>
                <div className="half-menu" style={{ width: "38%" }}>
                  <div className="date-select">
                    <div style={{ width: "140px", float: "left" }}>
                      <span>Start Date :</span>
                    </div>
                    <input
                      type="date"
                      className={contractEndDate}
                      required="required"
                      onChange={onChangeAutoRejectApplicationDateStart}
                      value={autoRejectApplicationDate.dateStart}
                      max={maxAutoRejectApplicationDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div className="half-menu" style={{ width: "38%" }}>
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>End Date : </span>
                    </div>
                    <input
                      type="date"
                      className={contractEndDate}
                      required="required"
                      onChange={onChangeAutoRejectApplicationDateEnd}
                      value={autoRejectApplicationDate.dateEnd}
                      min={minAutoRejectApplicationDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div style={{ float: "right", marginRight: "70px" }}>
                  <button
                    style={{
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#f5903d",
                      color: "#FFFFFF",
                      fontFamily: "gotham-bold",
                      width: "200px",
                    }}
                    onClick={() =>
                      generateAutoRejectedExpiringLoanApplicationReport()
                    }
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={eighthMenu}>
            <p className="title-text">Disbursement Report</p>
            <div className="card third-tab">
              <div>
                <div className="half-menu" style={{ width: "38%" }}>
                  <div className="date-select">
                    <div style={{ width: "140px", float: "left" }}>
                      <span>Start Date :</span>
                    </div>
                    <input
                      type="date"
                      className={contractEndDate}
                      required="required"
                      onChange={onChangeLoanContractDateStart}
                      value={loanContractDate.dateStart}
                      max={maxLoanContractDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div className="half-menu" style={{ width: "38%" }}>
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>End Date : </span>
                    </div>
                    <input
                      type="date"
                      className={contractEndDate}
                      required="required"
                      onChange={onChangeLoanContractDateEnd}
                      value={loanContractDate.dateEnd}
                      min={minLoanContractDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div style={{ float: "right", marginRight: "70px" }}>
                  <button
                    style={{
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#f5903d",
                      color: "#FFFFFF",
                      fontFamily: "gotham-bold",
                      width: "200px",
                    }}
                    onClick={() => generateDisbursementReport()}
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={ninthMenu}>
            <p className="title-text">Outstanding Report</p>
            <div className="card third-tab">
              <div>
                <div className="half-menu">
                  <div style={{ float: "left" }}>
                    <span>Select Date : </span>
                  </div>
                  <input
                    type="date"
                    className={contractEndDate}
                    onChange={onChangeSelectOutstandingDate}
                    value={selectOutstandingDate.date}
                    style={{ float: "left" }}
                  />
                </div>
                <div className="half-menu">
                  <div style={{ marginLeft: "220px" }}>
                    <button
                      style={{
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: "#f5903d",
                        color: "#FFFFFF",
                        fontFamily: "gotham-bold",
                        width: "200px",
                      }}
                      onClick={() => generateOutstandingReport()}
                    >
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={tenthMenu}>
            <p className="title-text">
              Merchant Transaction Without Proof Report
            </p>
            <div className="card third-tab">
              <div>
                <div className="half-menu">
                  <div style={{ float: "left" }}>
                    <span>Select Date : </span>
                  </div>
                  <input
                    type="date"
                    className={contractEndDate}
                    onChange={onChangeSelectTransactionDate}
                    value={selectTransactionDate.date}
                    style={{ float: "left" }}
                  />
                </div>
                <div style={{ float: "right", marginRight: "70px" }}>
                  <button
                    style={{
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#f5903d",
                      color: "#FFFFFF",
                      fontFamily: "gotham-bold",
                      width: "200px",
                    }}
                    onClick={() => generateTransactionWithoutProofReport()}
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={eleventhMenu}>
            <p className="title-text">Audit Trail Report</p>
            <div className="card third-tab">
              <div>
                <div className="half-menu" style={{ width: "38%" }}>
                  <div className="date-select">
                    <div style={{ width: "140px", float: "left" }}>
                      <span>Start Date :</span>
                    </div>
                    <input
                      type="date"
                      className={auditTrailStartDate}
                      required="required"
                      onChange={onChangeAuditTrailDateStart}
                      value={auditTrailDate.dateStart}
                      max={maxAuditTrailDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div className="half-menu" style={{ width: "38%" }}>
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>End Date : </span>
                    </div>
                    <input
                      type="date"
                      className={auditTrailEndDate}
                      required="required"
                      onChange={onChangeAuditTrailDateEnd}
                      value={auditTrailDate.dateEnd}
                      min={minAuditTrailDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div style={{ float: "right", marginRight: "70px" }}>
                  <button
                    style={{
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#f5903d",
                      color: "#FFFFFF",
                      fontFamily: "gotham-bold",
                      width: "200px",
                    }}
                    onClick={() => generateAuditTrailReport()}
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className={twelfthMenu}>
            <p className="title-text">Custom Audit Trail Report</p>
            <div className="card third-tab">
              <div>
                <div className="half-menu" style={{ width: "50%" }}>
                  <div className="date-select">
                    <div style={{ width: "140px", float: "left" }}>
                      <span>Start Date :</span>
                    </div>
                    <input
                      type="date"
                      className={customAuditTrailStartDate}
                      required="required"
                      onChange={onChangeCustomAuditTrailDateStart}
                      value={customAuditTrailDate.dateStart}
                      max={maxCustomAuditTrailDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div className="half-menu" style={{ width: "38%" }}>
                  <div className="date-select">
                    <div style={{ width: "120px", float: "left" }}>
                      <span>End Date : </span>
                    </div>
                    <input
                      type="date"
                      className={customAuditTrailEndDate}
                      required="required"
                      onChange={onChangeCustomAuditTrailDateEnd}
                      value={customAuditTrailDate.dateEnd}
                      min={minCustomAuditTrailDate}
                      style={{ float: "left" }}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "60px" }}>
                  <div className="half-menu" style={{ width: "50%" }}>
                    <div className="date-select">
                      <div style={{ width: "120px", float: "left" }}>
                        <span>Role :</span>
                      </div>
                      {roleList != undefined ? (
                        <select
                          className="merchant-input-text"
                          style={{ marginLeft: "20px", borderRadius: "5px" }}
                          value={role}
                          onChange={OnSelectRole}
                        >
                          <option value="">- Select role -</option>
                          {roleList
                            .sort((a, b) =>
                              a.sortOrder > b.sortOrder ? 1 : -1
                            )
                            .map((d, i) => (
                              <option value={d.value} key={i}>
                                {d.label}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select
                          className="merchant-input-text"
                          style={{ marginLeft: "10px", borderRadius: "5px" }}
                        >
                          <option value="- Select role -">
                            - Select role -
                          </option>
                        </select>
                      )}
                    </div>
                  </div>
                  <div className="half-menu">
                    <div className="date-select">
                      <div style={{ width: "120px", float: "left" }}>
                        <span>Name :</span>
                      </div>
                      {nameList &&
                      Array.isArray(nameList.nameList) &&
                      nameList.nameList.length > 0 ? (
                        <select
                          className="merchant-input-text"
                          style={{ borderRadius: "5px" }}
                          value={name}
                          onChange={OnChangeName}
                        >
                          {nameList.nameList
                            .filter(
                              (name) =>
                                typeof name === "string" && name.trim() !== ""
                            ) 
                            .sort((a, b) => a.localeCompare(b))
                            .map((name, i) => (
                              <option value={name} key={i}>
                                {name}
                              </option>
                            ))}
                        </select>
                      ) : (
                        <select
                          className="merchant-input-text"
                          style={{ marginLeft: "10px", borderRadius: "5px" }}
                        >
                          <option value="- Select Name -">
                            - Select Name -
                          </option>
                        </select>
                      )}
                    </div>
                  </div>
                </div>
                <div style={{ float: "right", marginTop: "15px" }}>
                  <button
                    style={{
                      border: "none",
                      borderRadius: "8px",
                      backgroundColor: "#f5903d",
                      color: "#FFFFFF",
                      fontFamily: "gotham-bold",
                      width: "200px",
                    }}
                    onClick={() => generateCustomAuditTrailReport()}
                  >
                    Generate
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageReportOthers;

const roleList = [
  {value: "USER", label: "User"},
  {value: "CREDIT_OFFICER", label: "Credit Officer"},
  {value: "MERCHANT", label: "Merchant"},
  {value: "SUPER_ADMIN", label: "Super Admin"},
  {value: "PROCESSING_OFFICER", label: "Processing Officer"},
  {value: "FINANCE", label: "Finance"},
  {value: "MASTER_ADMIN", label: "Master Admin"},
  {value: "ATTESTOR", label: "Attestor"},
  {value: "EXECUTIVE", label: "Executive"},
];
